import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { EventSkeletonComponent } from "../../components/event-skeleton/event-skeleton.component";

@Component({
  selector: 'hypenation-tickets-view-one-skeleton',
  standalone: true,
  imports: [CommonModule, NzSkeletonModule, EventSkeletonComponent],
  templateUrl: './view-one-skeleton.component.html',
  styleUrl: './view-one-skeleton.component.css',
})
export class ViewOneSkeletonComponent {}
